<template>
  <div class="gl-email-header">
    <div class="email-logo" @click="enterEmailFn()">
      <img :src="envConfig.logo || '../../assets/newLogo.png'" />
      <i>{{ envConfig.title || '吉利邮箱' }}</i>
    </div>
    <div class="login-info">
      <span class="user-email" id="user-email" @click="isMultiAccountFn()">
        <em>{{ emailAds }}</em>
        <!--<i class="el-icon-arrow-down"></i>-->
      </span>
      <!-- 退出 -->
      <span class="btn-logout" @click="loginOut">{{ $t("exit") }}</span>
      <!--多账号-->
      <div class="multi-account" id="multi-account" v-if="isMultiAccount">
        <div class="current-account">
          <span>您的当前邮箱账号：</span>
          <p title="yi.shi@geely.com">yi.shi@geely.com</p>
        </div>
        <div class="as-account">
          <ul v-if="asAccountData.length">
            <li>关联账号</li>
            <li>
              <span title="e-wanghuicong@geely.com">e-wanghuicong@geely.com</span>
              <i class="del el-icon-error" @click="delAccountFn()"></i>
            </li>
            <li>
              <span title="san.zhang@geely.com">san.zhang@geely.com</span>
              <i class="del el-icon-error" @click="delAccountFn()"></i>
            </li>
          </ul>
          <p v-else>将不同用途的邮箱关联在一起，无需登录即可随意切换。</p>
        </div>
        <div class="btn">
          <span @click="accountManageFn()">账号管理</span>
          <span @click="addAsAccountFn()">关联其他账号</span>
        </div>
      </div>
    </div>

    <!-- 快捷操作 -->
    <div class="quick-oprate">
      <!-- 刷新 -->
      <div class="refreshBtn quick-icon" ref="refreshBtn" @click="refreshFn()" :title="$t('refresh')">
        <i class="iconfont icon-shuaxin"></i>
      </div>
      <!-- 中英文切换 -->
      <div class="lang quick-icon">
        <Translate />
      </div>
      <!-- 进入邮件 -->
      <div :title="$t('enterMail')" @click="enterEmailFn()" class="gotoEmail quick-icon">
        <img src="../assets/gotoEmail.png" alt="" />
      </div>
      <!-- 查看日历 -->
      <router-link :title="$t('enterCalendar')" to="/CalendarView" class="calendar quick-icon">
        <img src="../assets/calendar.png" alt="" />
      </router-link>
      <!-- 进入bpm -->
      <a
        v-if="envConfig.showBpm"
        href="http://bpm.geely.com"
        target="_blank"
        class="bpm quick-icon"
        @click="$utils.countlyEvents.toBpm()"
        :title="$t('enterBPM')"
        ><img src="../assets/bpm.png" width="100%"
      /></a>

      <div class="email-search-box">
      <input
        type="text"
        v-model="searchInput"
        :placeholder="$t('enterTheContent')"
        @keydown.enter="searchFn"
      />
      <span class="btn-search" @click="searchFn">
        <i class="el-icon-search"></i>
      </span>
      <!-- 高级搜索 -->
      <span class="btn-advsearch" @click="highSearchFn">{{ $t("advancedSearch") }}</span>
    </div>
    </div>


    <!--高级搜索-->
    <el-dialog
      :title="$t('advancedSearch')"
      :visible.sync="highSearch"
      width="1000px"
      :close-on-click-modal="false"
    >
      <high-search
        @hideHighSearchDialog="hideHighSearchDialog"
        v-if="highSearch"
      ></high-search>
    </el-dialog>
    <!--关联其他账号-->
    <el-dialog
      title="关联其他吉利邮箱"
      :visible.sync="isAsAccount"
      width="60%"
      :close-on-click-modal="false"
    >
      <as-account @hideAsAccountDialog="hideAsAccountDialog"></as-account>
    </el-dialog>
  </div>
</template>
<script>
import asAccount from "@/components/asOtherAccount.vue";
import highSearch from "@/components/highSearchDialog.vue";
import Translate from "@/components/translate/index.vue";
export default {
  components: {
    highSearch,
    asAccount,
    Translate
  },
  data() {
    return {
      searchInput: "",
      emailAds: "",
      highSearch: false, //高级搜索显示、隐藏
      asAccountData: [0], //多账号信息
      isMultiAccount: false, //显示隐藏多账户信息
      isAsAccount: false, //显示隐藏-关联其他账户弹窗
      refreshRotate: 0, //刷新按钮旋转的度数
    };
  },
  created() {},
  beforeMount() {
    this.getEmailAds();
  },
  mounted() {
    //隐藏多账户
    document.body.addEventListener("mousedown", this.hideMultiAccountFn);
  },
  watch: {},
  computed: {
    localStorageAccount() {
      return localStorage.Account;
    },
    // 当前使用语言
    language() {
      return this.$store.state.Site.language;
    },
    envConfig() {
      const isAerofugia = location.origin.includes("aerofugia.com");
      if (isAerofugia) {
        return {
          title: '沃飞邮箱',
          logo: require('../assets/newLogo_aerofugia.png'),
          showBpm: false, // 沃飞邮箱不展示BPM入口
        }
      } else {
        return {
          title: '吉利邮箱',
          logo: require('../assets/newLogo.png'),
          showBpm: true,
        }
      }
    }
  },
  methods: {
    //获取邮箱信息
    getEmailAds() {
      this.emailAds = localStorage.UserName + "   " + localStorage.Account;
    },
    //退出
    loginOut() {
      // 您确定退出登录吗
      this.$confirm(this.$t("sureLogout"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
        .then(() => {
          // Countly.add_event({
          //   key: "用户退出",
          //   count: 1,
          //   segmentation: {
          //     username: localStorage.UserName,
          //     email: localStorage.Account,
          //     logoutTime: new Date().toLocaleString()
          //   }
          // })
          this.$api.post(
            `/${this.$utils.getApiPrefix().exchangeapi}/login/logout`,
            {},
            (res) => {
              if (res.Success) {
                this.$message({
                  type: "success",
                  message: res.Message,
                });
                this.$utils.clearLocalStorageUserInfo();

                this.$root.$emit("showPage", false);
                this.$router.push("/");
              }
            }
          );
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: res === "cancel" ? "已取消" : res,
          });
        });
    },
    //搜索（点击搜索图标、enter键搜索）
    searchFn() {
      if (this.searchInput) {
        // 记录搜索事件
        this.$utils.countlyEvents.mailSearch({ keyword: this.searchInput });
        let query = Object.assign({}, this.$route.query);
        if (query.searchType) {
          delete query.searchType;
        }
        query.searchText = this.searchInput;
        this.$router.push({
          path: "/index",
          query,
        });
      } else {
        // 请输入搜索内容
        this.$message({
          message: this.$t("enterSearchContent"),
          type: "warning",
          showClose: true,
        });
      }
    },
    //高级搜索
    highSearchFn() {
      this.highSearch = true;
    },
    hideHighSearchDialog() {
      // 记录搜索事件
      this.$utils.countlyEvents.mailAdSearch();

      this.highSearch = false;
    },
    //隐藏关联账户弹窗
    hideAsAccountDialog() {
      this.isAsAccount = false;
    },
    //显示、隐藏多账户
    isMultiAccountFn() {
      //this.isMultiAccount = !this.isMultiAccount
    },
    //隐藏多账户
    hideMultiAccountFn(event) {
      let e = window.event || event;
      if (
        !(
          e.target.id == "multi-account" ||
          $(e.target).parents("#multi-account").length > 0 ||
          e.target.id == "user-email" ||
          $(e.target).parents("#user-email").length > 0
        )
      ) {
        this.isMultiAccount = false;
      }
    },
    //切换关联账号
    switchAccountFn(token) {
      localStorage.Token = token;
      this.$router.go(0);
    },
    //删除关联账号
    delAccountFn(account) {
      // 确定解除该账号的关联吗
      this.$confirm(account + "-" + this.$t("sureDissociateAccount"), {
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("confirm"),
        type: "warning",
        showClose: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    //管理关联账号
    accountManageFn() {
      this.isMultiAccount = false;
      //进入邮箱设置页面-管理账号
      this.$router.push({ name: "set" });
    },
    //添加关联账号
    addAsAccountFn() {
      this.isMultiAccount = false;
      this.isAsAccount = true;
    },
    //进入邮件
    enterEmailFn() {
      this.$root.$emit("enterEmail");
    },
    //刷新
    refreshFn() {
      // 刷新按钮旋转
      this.refreshRotate += -360;
      let refreshBtn = this.$refs.refreshBtn;
      refreshBtn.style.transform = `rotate(${this.refreshRotate}deg)`;
      // 刷新左侧文件夹目录(日程视图页面是不展示左侧文件夹的)
      if (this.$route.name != "CalendarView") {
        this.$root.$emit("refreshFolders", "handleRefresh");
      }
      // 刷新邮件列表
      if (this.$route.name === "emailList") {
        this.$root.$emit("refreshEmailList");
      }
      // 刷新日程视图数据
      if (this.$route.name === "CalendarView") {
        this.$root.$emit("refreshCalendarView");
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.gl-email-header {
  font-family: "microsoft yahei";
  position: relative;
  //padding-right: 390px;
  .email-logo {
    cursor: pointer;
    float: left;
    // line-height: 60px;
    margin-top: 12px;
    margin-left: 10px;
    margin-right: 45px;
    img {
      vertical-align: middle;
      display: inline-block;
      margin-right: 5px;
    }
    > i {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      color: #fff;
      line-height: 20px;
      margin-top: 2px;
      letter-spacing: 2.33px;
      font-weight: 500;
    }
  }
  .login-info {
    float: left;
    line-height: 50px;
    color: #fff;
    font-size: 14px;
    position: relative;
    .user-email {
      display: inline-block;
      vertical-align: middle;
      // cursor: pointer;
      &:after {
        content: "|";
        font-size: 12px;
        padding: 0 15px;
      }
      em {
        display: inline-block;
        min-width: 150px;
        max-width: 260px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: bottom; /*解决overflow:hidden后错位问题*/
      }
      i {
        vertical-align: middle;
        transition: all 0.5s;
        -moz-transition: all 0.5s;
        -webkit-transition: all 0.5s;
        -o-transition: all 0.5s;
        &.login_info_arrow {
          transform: rotate(-180deg);
          -ms-transform: rotate(-180deg);
          -moz-transform: rotate(-180deg);
          -webkit-transform: rotate(-180deg);
          -o-transform: rotate(-180deg);
        }
      }
    }
    .btn-logout {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
    /*多账号*/
    .multi-account,
    .multi-account * {
      box-sizing: border-box;
    }
    .multi-account {
      line-height: normal;
      width: 240px;
      min-height: 150px;
      background-color: #fff;
      color: #333;
      border: 0 solid #dedede;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      z-index: 10;
      position: absolute;
      left: 88px;
      top: 45px;
      padding: 10px 15px;
      border-radius: 3px;
      &::before {
        content: "";
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #fff;
        position: absolute;
        left: 110px;
        top: -6px;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -o-transform: rotate(45deg);
      }
      .current-account {
        span {
          font-size: 12px;
          color: #666666;
        }
        p {
          font-size: 14px;
          color: #333333;
          border-bottom: 1px solid #ebeff2;
          padding: 6px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .as-account {
        padding: 10px 0 5px 0;
        ul {
          padding-bottom: 5px;
          li {
            font-size: 14px;
            color: #333333;
            line-height: 26px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            padding-right: 20px;
            position: relative;
            .del {
              position: absolute;
              right: 0;
              top: 8px;
              opacity: 0.6;
            }
          }
          li:first-of-type {
            font-size: 12px;
            color: #666666;
            cursor: auto;
          }
        }
        p {
          font-size: 12px;
          color: #999999;
        }
      }
      .btn {
        span {
          display: inline-block;
          width: 49%;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px solid #cbcbcb;
          border-radius: 3px;
          color: #333333;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
  .email-search-box {
    top: 9px;
    width: 345px;
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    * {
      float: left;
    }
    > input {
      height: 32px;
      line-height: 32px;
      width: 153px;
      border-radius: 16px;
      padding-left: 20px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &::input-placeholder {
        color: #c0c4cc;
      }
      &::-webkit-input-placeholder {
        color: #c0c4cc;
      }

      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: #c0c4cc;
      }
    }
    .btn-search {
      padding: 0 8px;
      height: 32px;
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      cursor: pointer;
      background: #fff;
      &:hover {
        background: #efefef;
      }
    }
    .el-icon-search {
      font-size: 20px;
      color: #999;
      margin-top: 6px;
    }
    .btn-advsearch {
      width: 116px;
      text-align: center;
      padding: 0 8px 0 10px;
      font-size: 14px;
      background: #fff;
      border-radius: 16px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      cursor: pointer;
      &:hover {
        background: #efefef;
      }
    }
  }

  .quick-oprate{
    height: 50px;
    float: right;
    display: flex;
    align-items: center;
    padding-right: 10px;
    .quick-icon{
      margin-right: 10px;
    }
  }
  .lang {
    display: inline-block;
    width: 30px;
    height: 30px;
  }
  .langColor {
    color: #fff;
  }
  .bpm {
    display: inline-block;
    width: 30px;
    height: 30px;
  }
  .calendar {
    display: inline-block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /*手动刷新按钮*/
  .refreshBtn {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #ffffff;
    transition: all 1s;
    -webkit-transition: all 1s;
    i {
      display: inline-block;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 50%;
      color: #296ab4;
      font-size: 16px;
      transform: rotateY(180deg);
      -webkit-transform: rotateY(180deg);
    }
  }
  .gotoEmail {
    display: inline-block;
    width: 30px;
    height: 30px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 28px;
    img {
      width: 56%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue